// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.

export const CUSTOM_WEB_APP_OPTIONS = [];
